import { Link } from "react-router-dom";
import TopicCard from "@/components/base/TopicCard";
import { topics } from "@/mocks/topics";

export default function LatestProgress() {
  const ordered = [...topics]
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
    .slice(0, 6);

  return (
    <section id="latest" className="scroll-mt-24">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">最新进展</h2>
          <p className="mt-2 text-sm text-foreground-600">每一个事件都已整理好时间线、争议点与回应。</p>
        </div>
        <Link
          to="/category/reyi"
          className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
        >
          查看全部事件
          <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {ordered.map((topic) => (
          <TopicCard key={topic.id} topic={topic} />
        ))}
      </div>
    </section>
  );
}